import projectLogger from '@/utils/project-log'
const { radar } = projectLogger.plugins
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (error, instance, info) => {
    console.log('===vue', error)
    // vue错误
    radar.captureException(error)
  })
  nuxtApp.hook('app:error', (error) => {
    // 启动错误
    radar.captureException(error)
  })
})
